import React from 'react';
import { motion } from 'framer-motion';
import { variants } from '../MotionVariants';

interface AnimatedDivProps {
  children: React.ReactNode;
}

const AnimatedDiv: React.FC<AnimatedDivProps> = ({ children }) => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={variants}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedDiv;